"use client"
import { Button } from "@/components/ui/button"
import { DialogClose } from "@/components/ui/dialog"
import Link from "next/link"
import { viewPostFromPublishSuccessModalClicked } from "../../../../tracking"
import Modal from "@/app/components/Modal"
import ShareButtonRow from "@/app/components/Modal/ShareModal/ShareButtonsRow"

export default function ShareModal({
  postId,
  postTitle,
  postUrl,
  headerTitle,
  headerDescription,
  openParam,
}: {
  postId: string
  postTitle: string
  postUrl: string
  headerTitle: string
  headerDescription: string
  openParam: string
}) {
  const footer = (
    <>
      <Link
        href={postUrl}
        target="_blank"
        onClick={() => viewPostFromPublishSuccessModalClicked(postId)}
      >
        <Button variant="secondary" className="w-full sm:w-fit">
          View Post
        </Button>
      </Link>
      <DialogClose asChild>
        <Button>Done</Button>
      </DialogClose>
    </>
  )

  const content = (
    <>
      <p className="text-foreground">{headerDescription}</p>
      <ShareButtonRow postId={postId} postUrl={postUrl} postTitle={postTitle} />
    </>
  )

  return (
    <Modal title={headerTitle} footer={footer} openParam={openParam}>
      {content}
    </Modal>
  )
}
